import Controller from '@/services/api/controller.js';

export default {
  namespaced: true,
  state: {
    controllers: [],
    controller: {},
    controllerEdit: {},
  },
  getters: {
    controllers: state => state.controllers,
    controller: state => state.controller,
    controllerEdit: state => state.controllerEdit,
  },
  mutations: {
    setControllers: (state, items) => {
      state.controllers = items;
    },
    setController: (state, item) => {
      state.controller = item;
    },
    setControllerEdit: (state, item) => {
      state.controllerEdit = item;
    },
  },
  actions: {
    loadAllControllers (state, options = {}) {
      return new Promise((resolve, reject) => {
        Controller.loadAllControllers(options)
          .then(({ data }) => {
            state.commit('setControllers', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getController (state, { id }) {
      return new Promise((resolve, reject) => {
        Controller.getController(id)
          .then(({ data }) => {
            state.commit('setController', data.controller);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getControllerInfoEdit (state, { id }) {
      return new Promise((resolve, reject) => {
        Controller.getControllerInfoEdit(id)
          .then(({ data }) => {
            state.commit('setControllerEdit', data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    newController (state, params) {
      return new Promise((resolve, reject) => {
        Controller.newController(params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateController (state, { id, params }) {
      return new Promise((resolve, reject) => {
        Controller.updateController(id, params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    removeController (state, { id }) {
      return new Promise((resolve, reject) => {
        Controller.removeController(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getSipStatus (state, id) {
      return new Promise((resolve, reject) => {
        Controller.getSipStatus(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    openDorController (state, id) {
      return new Promise((resolve, reject) => {
        Controller.openDorController(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
